export const translations = {
  fr: {
    org: "Groupe Havre d'Amour et de Paix",
    tagline: "Ressource Intermédiaire • Centre de Répit • Services intégrés",
    nav: {
      home: "Accueil",
      services: "Services",
      residences: "Résidences",
      about: "À propos",
      regions: "Régions",
      contact: "Contact",
      careers: "Carrières",
      donate: "Faire un don",
    },
    cta: {
      explore: "Découvrir nos services",
      donate: "Faire un don",
      contact: "Nous joindre",
      learnMore: "En savoir plus",
    },
    home: {
      heroBadge: "Au service des personnes vulnérables",
      heroTitle: "Accueillir avec amour, accompagner avec dignité",
      heroText:
        "Un milieu de vie chaleureux et sécuritaire pour les personnes vulnérables — aînés, personnes vivant avec une DI-TSA ou des enjeux de santé mentale — et un soutien précieux pour leurs proches aidants.",
      heroCardSub: "Sécurité & accompagnement permanents",
      deviseLabel: "Notre devise",
      devise:
        "« Accueillir avec amour, accompagner avec dignité, et ouvrir des chemins de vie vers plus de paix, d'autonomie et d'appartenance. »",
      servicesTitle: "Nos services",
      servicesSubtitle: "Un accompagnement humain, adapté à chaque personne.",
      missionTeaserTitle: "Une vision humaine et durable",
      missionTeaserText:
        "Au-delà de l'hébergement et du répit, nous bâtissons un écosystème de services en inclusion sociale, formation, employabilité et accompagnement communautaire.",
      donateBannerTitle: "Votre générosité transforme des vies",
      donateBannerText:
        "Chaque don nous aide à offrir un milieu de vie digne, sécuritaire et chaleureux aux personnes que nous accompagnons.",
    },
    servicesList: {
      title: "Nos services",
      subtitle: "Des services temporaires et à long terme, adaptés à chaque réalité.",
      hebergement: {
        title: "Hébergement (Ressource Intermédiaire)",
        desc: "Un milieu de vie sécuritaire de type RI offrant hébergement, repas et accompagnement quotidien, pour un court ou long séjour.",
      },
      repitJour: {
        title: "Répit au centre de jour",
        desc: "Une journée de répit en milieu accueillant, avec activités adaptées et présence rassurante.",
      },
      repitDomicile: {
        title: "Répit à domicile",
        desc: "Un accompagnement à domicile pour soutenir la personne et offrir un répit aux proches aidants.",
      },
      repitResidence: {
        title: "Répit en résidence",
        desc: "Un séjour de répit en résidence dans un environnement apaisant et encadré.",
      },
      everydayTitle: "Au quotidien",
      everyday: [
        "Activités de jour",
        "Formule 3 repas par jour",
        "Entretien de la literie",
        "Entretien ménager",
        "Entretien des vêtements",
        "Sécurité permanente 24h / 7j",
        "Services temporaires et à long terme",
        "Services à la carte",
      ],
      careTitle: "Soins de santé",
      care: [
        "Gestion, distribution et administration des médicaments",
        "Aide à l'alimentation et à l'habillement",
        "Aide au bain, au lever et aux déplacements",
        "Visite de spécialistes à la résidence",
        "Soins de convalescence et d'hygiène",
        "Soins invasifs d'assistance à la vie quotidienne",
        "Accompagnement aux rendez-vous médicaux",
      ],
      leisureTitle: "Loisirs et activités",
      leisure: [
        "Bibliothèque",
        "Bingo",
        "Chant",
        "Programme d'activités adaptées",
        "Jeux de société",
        "Loisirs disponibles",
        "Jeux de cartes",
        "Activités variées (selon l'horaire établi)",
        "Activités et sorties à l'extérieur",
      ],
      clientTitle: "Notre clientèle",
      clients: [
        "Personnes âgées",
        "Personnes vivant avec une DI-TSA",
        "Santé mentale",
        "Personnes semi-autonomes et autonomes",
        "Court ou long séjour",
      ],
    },
    residences: {
      title: "Nos résidences",
      subtitle:
        "Des milieux de vie chaleureux et apaisants, pensés pour le bien-être et la dignité. De nouvelles résidences s'ajouteront à notre réseau.",
      introTitle: "Un véritable milieu de vie",
      introText:
        "Nos résidences sont conçues comme de vrais milieux de vie : lumineux, sécuritaires et chaleureux. Chaque espace favorise la tranquillité, les rencontres et le sentiment d'appartenance, dans le respect du rythme de chaque personne.",
      featuresTitle: "Nos espaces et commodités",
      features: [
        { title: "Chambres confortables", desc: "Des chambres accueillantes et adaptées, avec entretien de la literie et des vêtements." },
        { title: "Espaces communs chaleureux", desc: "Salons lumineux et conviviaux pour se rassembler, se reposer et partager des moments." },
        { title: "Salle à manger", desc: "Formule 3 repas par jour, des repas chauds et nutritifs servis dans un cadre agréable." },
        { title: "Sécurité 24h / 7j", desc: "Une présence permanente pour la tranquillité d'esprit des résidents et des familles." },
        { title: "Soins sur place", desc: "Gestion des médicaments, soins d'hygiène et visite de spécialistes à la résidence." },
        { title: "Espaces de loisirs", desc: "Des aires dédiées aux activités, aux jeux et à la détente." },
      ],
      galleryTitle: "Galerie",
      leisureIntro: "La vie en résidence est rythmée par des activités variées et adaptées :",
      note: "Photos d'une de nos résidences.",
      ctaTitle: "Envie d'en savoir plus ?",
      ctaText: "Contactez-nous pour une visite ou une demande d'admission.",
    },
    about: {
      title: "À propos de nous",
      visionTitle: "Notre vision",
      vision:
        "Être un milieu vivant, durable et évolutif qui incarne l'amour, la dignité et la paix, tout en répondant avec humanité aux besoins changeants des personnes et des communautés. Nous aspirons à bâtir un écosystème de services où chaque personne — qu'elle vive avec une perte d'autonomie, des enjeux de santé mentale, une déficience intellectuelle, un trouble du spectre de l'autisme, ou qu'elle soit une personne aînée ou un proche aidant — trouve un espace de sécurité, de reconnaissance et de croissance.",
      missionTitle: "Notre mission",
      mission:
        "Le Groupe Havre d'Amour et de Paix a pour mission de créer et de développer des milieux de vie, de répit et de services humains intégrés, où chaque personne est accueillie dans sa globalité, respectée dans son unicité et soutenue dans son cheminement.",
      engagementsTitle: "Nos engagements",
      engagements: [
        "Offrir un accompagnement sécuritaire, chaleureux et centré sur la personne",
        "Soutenir le bien-être global des personnes accompagnées et de leurs proches",
        "Prévenir l'isolement, l'épuisement et la rupture sociale",
        "Favoriser l'autonomie, l'inclusion et la participation sociale",
        "Accompagner les parcours de réinsertion sociale et de développement personnel",
        "Créer des passerelles vers la formation, l'emploi et la vie communautaire",
        "Travailler en collaboration avec les familles, les partenaires et le réseau de la santé",
      ],
      valuesTitle: "Nos valeurs",
      values: [
        { name: "L'amour", desc: "L'amour véritable se manifeste dans l'écoute, la présence, la patience et le respect profond de l'autre." },
        { name: "La dignité", desc: "Chaque personne porte une valeur inestimable que nous reconnaissons, préservons et faisons grandir." },
        { name: "La paix", desc: "Des environnements apaisants où la confiance, la sécurité et l'harmonie permettent de se reconstruire." },
        { name: "L'inclusion", desc: "Une société où personne n'est laissé de côté et où chacun peut participer et exister pleinement." },
        { name: "L'autonomie", desc: "Soutenir chaque personne dans le développement de ses capacités, de ses choix et de sa liberté d'agir." },
        { name: "La réinsertion sociale", desc: "Accompagner la reprise de confiance, des liens sociaux et de la participation à la vie collective." },
        { name: "La collaboration", desc: "Avancer avec les familles, les proches aidants et les partenaires, dans la confiance et le respect." },
        { name: "L'excellence humaine", desc: "Une qualité de service mesurée à l'impact humain et à la transformation positive des vies." },
      ],
      engagementTitle: "Notre engagement",
      engagementText:
        "Nous croyons que chaque personne porte en elle une histoire, une valeur et un potentiel qui méritent d'être reconnus. Notre engagement est de bâtir un milieu où les personnes ne sont pas seulement accompagnées, mais véritablement accueillies, soutenues et encouragées à reprendre leur place dans la vie sociale, familiale et communautaire.",
    },
    regions: {
      title: "Une présence qui grandit",
      subtitle:
        "Nous développons progressivement notre présence à travers le Québec et la région d'Ottawa, afin d'offrir nos services au plus près des familles.",
      cards: [
        { name: "Montréal", status: "Résidence active", areas: "Montréal et ses environs : Laval, Rive-Sud, Rive-Nord", desc: "Notre point d'ancrage, au cœur du centre-ville de Montréal, où nous accueillons les personnes en hébergement et en répit." },
        { name: "Outaouais", status: "En développement", areas: "Gatineau, Hull, Aylmer et les environs", desc: "Un projet de milieu de vie et de répit pour répondre aux besoins grandissants de la région de l'Outaouais." },
        { name: "Mauricie", status: "En développement", areas: "Trois-Rivières, Shawinigan et les environs", desc: "Le déploiement de services de proximité en Mauricie, en collaboration avec les familles et les partenaires locaux." },
        { name: "Ottawa", status: "En développement", areas: "Ottawa, Orléans, Nepean et la région de la capitale", desc: "Une présence pensée pour les familles de la région d'Ottawa, dans un esprit de continuité et de proximité." },
      ],
      statsTitle: "Notre portée",
      stats: [
        { value: "4", label: "Régions desservies ou en développement" },
        { value: "24/7", label: "Accompagnement et sécurité" },
        { value: "100%", label: "Approche centrée sur la personne" },
      ],
      future: "Et d'autres régions à venir…",
      ctaTitle: "Une présence dans votre région ?",
      ctaText: "Contactez-nous pour connaître nos services disponibles ou pour discuter d'un projet dans votre communauté.",
    },
    donation: {
      title: "Faire un don",
      subtitle:
        "Votre générosité nous permet d'offrir amour, dignité et paix aux personnes que nous accompagnons.",
      frequencyOneTime: "Don unique",
      frequencyMonthly: "Don mensuel",
      chooseAmount: "Choisissez un montant",
      customAmount: "Autre montant",
      customPlaceholder: "Montant en $ CAD",
      donorName: "Votre nom (optionnel)",
      donorEmail: "Votre courriel (optionnel)",
      donateNow: "Donner",
      processing: "Traitement…",
      monthlyNote: "",
      secure: "Paiement sécurisé par Stripe",
      impactTitle: "Votre impact",
      impacts: [
        "Des repas chauds et nutritifs chaque jour",
        "Des activités et sorties pour briser l'isolement",
        "Un environnement sécuritaire et chaleureux 24h/7j",
      ],
    },
    donationResult: {
      checking: "Vérification de votre paiement…",
      successTitle: "Merci de tout cœur !",
      successText: "Votre don a bien été reçu. Votre générosité fait une réelle différence.",
      pending: "Votre paiement est en cours de traitement…",
      failedTitle: "Le paiement n'a pas abouti",
      failedText: "Aucun montant n'a été prélevé. Vous pouvez réessayer.",
      timeout: "La vérification a expiré. Vérifiez votre courriel pour la confirmation.",
      backHome: "Retour à l'accueil",
      tryAgain: "Réessayer",
    },
    contact: {
      title: "Contactez-nous",
      subtitle: "Une question, une demande d'admission ou un besoin de répit ? Écrivez-nous.",
      infoTitle: "Coordonnées",
      phone: "Téléphone",
      email: "Courriel",
      address: "Adresse",
      addressValue: "245 boulevard Robert Bourassa, unité 1104, Montréal, QC, H3C 1A4",
      formName: "Nom complet",
      formEmail: "Courriel",
      formPhone: "Téléphone",
      formSubject: "Sujet",
      formMessage: "Votre message",
      send: "Envoyer le message",
      sending: "Envoi…",
      success: "Merci ! Votre message a bien été envoyé.",
      error: "Une erreur est survenue. Veuillez réessayer.",
    },
    careers: {
      title: "Travailler avec nous",
      subtitle:
        "Vous souhaitez mettre votre cœur et vos compétences au service des personnes vulnérables ? Joignez notre équipe.",
      intro: "Envoyez-nous votre candidature et votre CV. Nous vous recontacterons dès qu'une occasion correspond à votre profil.",
      formName: "Nom complet",
      formEmail: "Courriel",
      formPhone: "Téléphone",
      formPosition: "Poste recherché",
      formMessage: "Message / Lettre de motivation",
      formCv: "Joindre votre CV",
      cvHint: "PDF, DOC ou DOCX — max 5 Mo",
      chooseFile: "Choisir un fichier",
      noFile: "Aucun fichier sélectionné",
      send: "Envoyer ma candidature",
      sending: "Envoi…",
      success: "Merci ! Votre candidature a bien été envoyée.",
      error: "Une erreur est survenue. Veuillez réessayer.",
      cvRequired: "Veuillez joindre votre CV.",
      cvTooBig: "Le fichier dépasse 5 Mo.",
      whyTitle: "Pourquoi nous rejoindre",
      why: [
        "Un milieu de travail humain, bienveillant et respectueux",
        "Un impact réel et concret dans la vie des personnes",
        "Une équipe collaborative et solidaire",
      ],
    },
    cookies: {
      text: "Nous utilisons des témoins (cookies) pour améliorer votre expérience. Conformément à la Loi 25, vous pouvez accepter ou refuser. Voir notre politique de confidentialité.",
      accept: "Tout accepter",
      reject: "Tout refuser",
    },
    footer: {
      rights: "Tous droits réservés.",
      quickLinks: "Liens rapides",
      contact: "Coordonnées",
      mission: "Accueillir avec amour, accompagner avec dignité.",
    },
    admin: {
      title: "Administration",
      enterToken: "Entrez le code d'accès",
      access: "Accéder",
      messages: "Messages de contact",
      donations: "Dons",
      noMessages: "Aucun message.",
      noDonations: "Aucun don.",
      noApplications: "Aucune candidature.",
      wrongToken: "Code d'accès invalide.",
    },
  },

  en: {
    org: "Groupe Havre d'Amour et de Paix",
    tagline: "Intermediate Resource • Respite Centre • Integrated services",
    nav: {
      home: "Home",
      services: "Services",
      residences: "Residences",
      about: "About",
      regions: "Regions",
      contact: "Contact",
      careers: "Careers",
      donate: "Donate",
    },
    cta: {
      explore: "Explore our services",
      donate: "Donate",
      contact: "Contact us",
      learnMore: "Learn more",
    },
    home: {
      heroBadge: "Serving vulnerable people",
      heroTitle: "Welcoming with love, caring with dignity",
      heroText:
        "A warm and safe living environment for vulnerable people — seniors, individuals living with an intellectual disability / ASD or mental health challenges — and valuable support for their caregivers.",
      heroCardSub: "Round-the-clock security & support",
      deviseLabel: "Our motto",
      devise:
        "\"Welcoming with love, caring with dignity, and opening paths to more peace, autonomy and belonging.\"",
      servicesTitle: "Our services",
      servicesSubtitle: "Human, person-centred support tailored to each individual.",
      missionTeaserTitle: "A human and sustainable vision",
      missionTeaserText:
        "Beyond housing and respite, we are building an ecosystem of services in social inclusion, training, employability and community support.",
      donateBannerTitle: "Your generosity transforms lives",
      donateBannerText:
        "Every donation helps us offer a dignified, safe and warm living environment to the people we support.",
    },
    servicesList: {
      title: "Our services",
      subtitle: "Temporary and long-term services, adapted to each reality.",
      hebergement: {
        title: "Housing (Intermediate Resource)",
        desc: "A safe RI-type living environment offering housing, meals and daily support, for short or long stays.",
      },
      repitJour: {
        title: "Day-centre respite",
        desc: "A day of respite in a welcoming setting, with adapted activities and a reassuring presence.",
      },
      repitDomicile: {
        title: "In-home respite",
        desc: "In-home support for the person and respite for family caregivers.",
      },
      repitResidence: {
        title: "Residential respite",
        desc: "A respite stay in a residence within a calming, supervised environment.",
      },
      everydayTitle: "Everyday life",
      everyday: [
        "Daytime activities",
        "Three meals a day",
        "Bed linen care",
        "Housekeeping",
        "Laundry service",
        "24/7 permanent security",
        "Temporary and long-term services",
        "À la carte services",
      ],
      careTitle: "Health care",
      care: [
        "Medication management, distribution and administration",
        "Assistance with eating and dressing",
        "Help with bathing, getting up and moving around",
        "Specialist visits at the residence",
        "Convalescence and hygiene care",
        "Invasive daily living assistance care",
        "Accompaniment to medical appointments",
      ],
      leisureTitle: "Leisure & activities",
      leisure: [
        "Library",
        "Bingo",
        "Singing",
        "Adapted activities program",
        "Board games",
        "Available leisure activities",
        "Card games",
        "Varied activities (per the set schedule)",
        "Outdoor activities and outings",
      ],
      clientTitle: "Who we serve",
      clients: [
        "Seniors",
        "People living with an intellectual disability / ASD",
        "Mental health",
        "Semi-autonomous and autonomous individuals",
        "Short or long stays",
      ],
    },
    residences: {
      title: "Our residences",
      subtitle:
        "Warm and calming living environments, designed for well-being and dignity. New residences will be added to our network.",
      introTitle: "A true living environment",
      introText:
        "Our residences are designed as real living environments: bright, safe and warm. Every space fosters calm, connection and a sense of belonging, while respecting each person's own pace.",
      featuresTitle: "Our spaces and amenities",
      features: [
        { title: "Comfortable rooms", desc: "Welcoming, adapted rooms with bed linen and laundry care." },
        { title: "Warm common areas", desc: "Bright, friendly lounges to gather, rest and share moments." },
        { title: "Dining room", desc: "Three meals a day — warm, nutritious meals served in a pleasant setting." },
        { title: "24/7 security", desc: "A permanent presence for the peace of mind of residents and families." },
        { title: "On-site care", desc: "Medication management, hygiene care and specialist visits at the residence." },
        { title: "Leisure spaces", desc: "Dedicated areas for activities, games and relaxation." },
      ],
      galleryTitle: "Gallery",
      leisureIntro: "Life in the residence is filled with varied, adapted activities:",
      note: "Photos of one of our residences.",
      ctaTitle: "Want to learn more?",
      ctaText: "Contact us for a visit or an admission request.",
    },
    about: {
      title: "About us",
      visionTitle: "Our vision",
      vision:
        "To be a living, sustainable and evolving environment that embodies love, dignity and peace, while responding with humanity to the changing needs of people and communities. We aspire to build an ecosystem of services where every person — whether living with a loss of autonomy, mental health challenges, an intellectual disability, autism spectrum disorder, or being a senior or a caregiver — finds a space of safety, recognition and growth.",
      missionTitle: "Our mission",
      mission:
        "The Havre d'Amour et de Paix Group's mission is to create and develop living environments, respite and integrated human services, where every person is welcomed in their entirety, respected in their uniqueness and supported in their journey.",
      engagementsTitle: "Our commitments",
      engagements: [
        "Provide safe, warm and person-centred support",
        "Support the overall well-being of those we care for and their loved ones",
        "Prevent isolation, exhaustion and social rupture",
        "Foster autonomy, inclusion and social participation",
        "Support social reintegration and personal development journeys",
        "Create bridges to training, employment and community life",
        "Work in collaboration with families, partners and the health network",
      ],
      valuesTitle: "Our values",
      values: [
        { name: "Love", desc: "True love is expressed through listening, presence, patience and deep respect for others." },
        { name: "Dignity", desc: "Every person carries an invaluable worth that we recognize, preserve and help grow." },
        { name: "Peace", desc: "Calming environments where trust, safety and harmony allow people to rebuild." },
        { name: "Inclusion", desc: "A society where no one is left behind and everyone can participate and fully exist." },
        { name: "Autonomy", desc: "Supporting each person in developing their abilities, choices and freedom to act." },
        { name: "Social reintegration", desc: "Supporting the rebuilding of confidence, social ties and participation in community life." },
        { name: "Collaboration", desc: "Moving forward with families, caregivers and partners, in trust and respect." },
        { name: "Human excellence", desc: "A quality of service measured by human impact and the positive transformation of lives." },
      ],
      engagementTitle: "Our pledge",
      engagementText:
        "We believe that every person carries a story, a worth and a potential that deserve to be recognized. Our pledge is to build an environment where people are not only supported, but truly welcomed, encouraged and helped to reclaim their place in social, family and community life.",
    },
    regions: {
      title: "A growing presence",
      subtitle:
        "We are gradually developing our presence across Quebec and the Ottawa area, to bring our services closer to families.",
      cards: [
        { name: "Montreal", status: "Active residence", areas: "Montreal and surrounding areas: Laval, South Shore, North Shore", desc: "Our anchor point, in the heart of downtown Montreal, where we welcome people for housing and respite." },
        { name: "Outaouais", status: "In development", areas: "Gatineau, Hull, Aylmer and surrounding areas", desc: "A living and respite environment project to meet the growing needs of the Outaouais region." },
        { name: "Mauricie", status: "In development", areas: "Trois-Rivières, Shawinigan and surrounding areas", desc: "Rolling out local services in Mauricie, in collaboration with families and local partners." },
        { name: "Ottawa", status: "In development", areas: "Ottawa, Orléans, Nepean and the capital region", desc: "A presence designed for families in the Ottawa region, in a spirit of continuity and closeness." },
      ],
      statsTitle: "Our reach",
      stats: [
        { value: "4", label: "Regions served or in development" },
        { value: "24/7", label: "Support and security" },
        { value: "100%", label: "Person-centred approach" },
      ],
      future: "And more regions to come…",
      ctaTitle: "A presence in your region?",
      ctaText: "Contact us to learn about our available services or to discuss a project in your community.",
    },
    donation: {
      title: "Make a donation",
      subtitle:
        "Your generosity allows us to offer love, dignity and peace to the people we support.",
      frequencyOneTime: "One-time gift",
      frequencyMonthly: "Monthly gift",
      chooseAmount: "Choose an amount",
      customAmount: "Other amount",
      customPlaceholder: "Amount in CAD $",
      donorName: "Your name (optional)",
      donorEmail: "Your email (optional)",
      donateNow: "Donate",
      processing: "Processing…",
      monthlyNote: "",
      secure: "Secure payment by Stripe",
      impactTitle: "Your impact",
      impacts: [
        "Warm, nutritious meals every day",
        "Activities and outings to break isolation",
        "A safe and warm environment 24/7",
      ],
    },
    donationResult: {
      checking: "Verifying your payment…",
      successTitle: "Thank you so much!",
      successText: "Your donation was received. Your generosity makes a real difference.",
      pending: "Your payment is being processed…",
      failedTitle: "The payment did not go through",
      failedText: "No amount was charged. You can try again.",
      timeout: "Verification timed out. Please check your email for confirmation.",
      backHome: "Back to home",
      tryAgain: "Try again",
    },
    contact: {
      title: "Contact us",
      subtitle: "A question, an admission request or a need for respite? Write to us.",
      infoTitle: "Contact information",
      phone: "Phone",
      email: "Email",
      address: "Address",
      addressValue: "245 Robert Bourassa Blvd, unit 1104, Montreal, QC, H3C 1A4",
      formName: "Full name",
      formEmail: "Email",
      formPhone: "Phone",
      formSubject: "Subject",
      formMessage: "Your message",
      send: "Send message",
      sending: "Sending…",
      success: "Thank you! Your message has been sent.",
      error: "An error occurred. Please try again.",
    },
    careers: {
      title: "Work with us",
      subtitle:
        "Would you like to put your heart and skills at the service of vulnerable people? Join our team.",
      intro: "Send us your application and résumé. We will get back to you as soon as an opportunity matches your profile.",
      formName: "Full name",
      formEmail: "Email",
      formPhone: "Phone",
      formPosition: "Desired position",
      formMessage: "Message / Cover letter",
      formCv: "Attach your résumé",
      cvHint: "PDF, DOC or DOCX — max 5 MB",
      chooseFile: "Choose a file",
      noFile: "No file selected",
      send: "Send my application",
      sending: "Sending…",
      success: "Thank you! Your application has been sent.",
      error: "An error occurred. Please try again.",
      cvRequired: "Please attach your résumé.",
      cvTooBig: "The file exceeds 5 MB.",
      whyTitle: "Why join us",
      why: [
        "A human, caring and respectful workplace",
        "A real, concrete impact on people's lives",
        "A collaborative and supportive team",
      ],
    },
    cookies: {
      text: "We use cookies to improve your experience. In accordance with Law 25, you can accept or decline. See our privacy policy.",
      accept: "Accept all",
      reject: "Reject all",
    },
    footer: {
      rights: "All rights reserved.",
      quickLinks: "Quick links",
      contact: "Contact",
      mission: "Welcoming with love, caring with dignity.",
    },
    admin: {
      title: "Administration",
      enterToken: "Enter access code",
      access: "Access",
      messages: "Contact messages",
      donations: "Donations",
      noMessages: "No messages.",
      noDonations: "No donations.",
      noApplications: "No applications.",
      wrongToken: "Invalid access code.",
    },
  },
};
